import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft, Download } from 'lucide-react';
import { STATUS_COLORS } from './constants';

export function RequestHeader({ request, exporting, onExportPDF }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="sm" onClick={() => navigate('/requests')} className="text-sm h-8">
          <ArrowLeft size={15} className="mr-1" /> {t('back')}
        </Button>
        <h1 className="text-xl font-semibold text-gray-900">
          {t('request')} {request.request_number ? `#${request.request_number}` : ''}
        </h1>
        <Badge className={`text-xs px-2.5 py-0.5 font-normal pointer-events-none select-none ${STATUS_COLORS[request.request_status]}`}>
          {request.request_status?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
        </Badge>
      </div>
      <Button data-testid="export-pdf-btn" variant="outline" size="sm" onClick={onExportPDF} disabled={exporting} className="text-sm h-8 border-gray-200">
        <Download size={14} className="mr-1.5" /> {exporting ? '...' : 'PDF'}
      </Button>
    </div>
  );
}
